import { rootRoute } from './root'
import { listRoute } from './list'
import { invitationsRoute } from './invitations'

export const userManagementRoute = rootRoute.addChildren([listRoute, invitationsRoute])
